module.exports = __webpack_public_path__ + "static/media/canTakeImportant.17468d35.mp3";